module.exports = __webpack_public_path__ + "static/media/vegitables_63.95972c07.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_63.csv
// module id = 650
// module chunks = 0